import * as React from "react";
import { fastObjectShallowCompare } from "./fastObjectShallowCompare.es.js";
function fastMemo(component) {
  return /* @__PURE__ */ React.memo(component, fastObjectShallowCompare);
}
export {
  fastMemo
};
//# sourceMappingURL=fastMemo.es.js.map
